<script>
  import { MainForm, Advantages, HowWeWork, Faq, ReviewsSlider, Link, imgSrc } from '$client';
  export let data;
  $: promotionsPage = data.promotionsPage;
  $: reviews = data.reviews;
  $: promotions = data.promotions;
</script>

<section id="main" class="margin-bottom">
  <section class="container margin-block">
    <h1 class="margin-bottom h1">{promotionsPage.header}</h1>
    <nav>
      <ul>
        {#each promotions as promotion}
          <li>
            <Link href={'/akcii/' + promotion.attributes.url}>
              <img
                height="224"
                width="290"
                src={imgSrc(promotion.attributes.cardImg.data.attributes.url)}
                alt={promotion.attributes.cardImg.data.attributes.alternativeText} />
              <span>{promotion.attributes.header}</span>
            </Link>
          </li>
        {/each}
      </ul>
    </nav>
  </section>
  <section class="container advantages margin-block">
    <h2 class="h2">{promotionsPage.advantages.header}</h2>
    <Advantages data={promotionsPage.advantages.data} />
  </section>
  <HowWeWork data={promotionsPage.howWeWork} />
  <MainForm data={promotionsPage.form.data.attributes} />
  <ReviewsSlider data={reviews} />
  <Faq data={promotionsPage.faq.data.attributes} />
</section>

<style lang="scss">
  #main {
    :global(.faq) {
      margin-block: 50px;

      @media only screen and (max-width: 767.98px) {
        margin-block: 30px;
      }
    }
  }

  ul {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 30px;
    align-items: center;
    justify-content: center;
    width: 100%;

    @media only screen and (max-width: 991.98px) {
      grid-template-columns: repeat(3, 1fr);
    }

    @media only screen and (max-width: 767.98px) {
      grid-template-columns: repeat(2, 1fr);
    }

    @media only screen and (max-width: 480px) {
      display: inline-flex;
      grid-template-columns: none;
      align-items: flex-start;
      justify-content: space-between;
      overflow: auto hidden;
    }

    img {
      width: 100%;
      object-fit: cover;
      border-radius: 15px;

      @media only screen and (max-width: 1199.98px) {
        min-width: 200px;
        height: 134px;
      }
    }

    :global(a) {
      display: flex;
      flex-direction: column;
      gap: 15px;
      align-items: flex-start;
      color: rgb(44 51 60 / 100%);
      font-weight: 600;
      font-size: 16px;
      font-family:
        Vela Sans,
        sans-serif;
    }
  }

  h1 {
    color: #2c333c;
    font-weight: 800;
    font-family: Vela Sans;
    font-style: normal;
  }

  .advantages h2 {
    margin-bottom: 50px;
    color: #2c333c;
    font-weight: 800;
    font-family: Vela Sans;
  }
</style>
